import { isEmpty, find, includes } from 'lodash';
import { transformValuesToString } from './utils';
import {
  GENERIC_DISQUALIFICATION,
  DISQUALIFICATION_USER_UNDERAGE,
} from './constants';

Pollfish.demographics = (function demographics() {
  let tagQuestions = [];
  let answeredQuestions = [];
  let savedAnswers = [];
  let isDisqualified = false;
  let hasAnsweredAllDemographics = false;
  let disqualifyImmediately = false;
  let disqualificationData = {};
  return {
    setQuestions(questions = []) {
      tagQuestions = questions.map((question) => ({
        ...question,
        isTag: true,
      }));

      isDisqualified = false;
      if (isEmpty(questions)) {
        hasAnsweredAllDemographics = true;
      } else {
        hasAnsweredAllDemographics = false;
      }

      // we can refrain from deleting those if we want to keep history
      savedAnswers = [];
      answeredQuestions = [];
    },
    reset() {
      answeredQuestions = [];
      savedAnswers = [];
      isDisqualified = false;
      hasAnsweredAllDemographics = false;
      disqualifyImmediately = false;
      disqualificationData = {};
      if (isEmpty(tagQuestions)) {
        hasAnsweredAllDemographics = true;
      } else {
        hasAnsweredAllDemographics = false;
      }
      // we can refrain from deleting those if we want to keep history
      savedAnswers = [];
      answeredQuestions = [];
    },
    getQuestions() {
      return tagQuestions;
    },
    isPending() {
      return !isEmpty(tagQuestions) && !hasAnsweredAllDemographics;
    },
    isCompleted() {
      return isEmpty(tagQuestions) || hasAnsweredAllDemographics;
    },
    getNextQuestion() {
      if (isDisqualified && disqualifyImmediately) {
        return null;
      }
      const pendingQuestion = find(
        tagQuestions,
        (question) => !includes(answeredQuestions, question.id),
      );
      return pendingQuestion;
    },
    getQuestionByRefId(refId) {
      return find(tagQuestions, ['refId', refId]);
    },
    getQuestionById(id) {
      return find(tagQuestions, ['id', id]);
    },
    getDisqualificationReason() {
      return disqualificationData.reason;
    },
    getDisqualificationData() {
      return disqualificationData;
    },
    setDisqualified(value, question, selectedAnswers) {
      disqualificationData = {
        question,
        selectedAnswers,
        reason: GENERIC_DISQUALIFICATION,
      };
      if (
        value === true &&
        question &&
        question.f_name === 'dg_year_of_birth'
      ) {
        // TODO: change this
        const isUpperAgeRange = selectedAnswers.some(
          (answer) => answer.body.indexOf('> 200') > -1,
        );
        if (isUpperAgeRange) {
          disqualificationData.reason = DISQUALIFICATION_USER_UNDERAGE;
          disqualifyImmediately = true;
        }
      } else if (question && question.f_name === 'dg_speaking_langs') {
        // if a respondent has english selected and says that they
        // don't want to respond to english we disqualify immediately.
        disqualifyImmediately = true;
      }
      isDisqualified = value;
    },
    isDisqualified() {
      return isDisqualified;
    },
    shouldDisqualifyImmediately() {
      return disqualifyImmediately;
    },
    saveAnswer(requestObject) {
      // NOTE: we can check here if a user has already answered the given question!
      // or at least if we know it since we keep it in-memory
      const answeredQuestion = requestObject.q_id;
      if (!answeredQuestion) {
        throw new Error('Missing answered question from request object');
      }
      // we save these answers so that the backend will receive them all together
      // but the backend expects their values as strings s_id, ttc etc
      savedAnswers.push(transformValuesToString(requestObject));
      answeredQuestions.push(answeredQuestion);

      if (answeredQuestions.length === tagQuestions.length) {
        hasAnsweredAllDemographics = true;
      }
      // send the selected answer to the server
      Pollfish.mobile.interface.sendToServer(
        '/v2/device/set/tag/question/answered',
        requestObject,
        true,
      );
    },
    getStoredAnswers() {
      return savedAnswers;
    },
  };
})();

export default Pollfish.demographics;
